<script>
export default {
  props: {
    value: {
      type: Object
    },
    id: {
      type: String
    },
    date: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean
    }
  },
  computed: {
    //create a list to select times in 30 min increments
    minMaxTime() {
      let minTime = 0
      let minMinutes = 0
      if (this.isToday(new Date(this.date))) {
        const time = this.momentDate(new Date())
        minTime = time.minutes() < 30 ? time.hour() : time.hour() + 1
        minMinutes = time.minutes() < 30 ? 30 : 0
      }
      return { minTime: minTime, minMinutes: minMinutes }
    },
    time() {
      const minMaxTime = this.minMaxTime
      const minTime = minMaxTime.minTime
      const maxTime = 23
      let hour = 0
      let minutes = minMaxTime.minMinutes
      let time = []
      for (let i = minTime; i <= maxTime; i++) {
        hour = this.forceTwoDigits(i)
        const startCondition =
          i === minMaxTime.minTime ? (minMaxTime.minMinutes < 30 ? 0 : 1) : 0
        for (let x = startCondition; x <= 1; x++) {
          minutes = this.forceTwoDigits(x == 1 ? 30 : 0)
          Array.push(time, {
            text: hour + ':' + minutes,
            value: { hour: hour, minutes: minutes }
          })
        }
      }
      return time
    }
  },
  methods: {
    forceTwoDigits(num) {
      return (num < 10 ? '0' : '') + num
    }
  }
}
</script>
<template>
  <v-select
    :id="id"
    :value="value"
    :items="time"
    item-text="text"
    item-value="value"
    label="Um"
    :menu-props="{ auto: true, contentClass: 'menu_extended_height' }"
    hide-details
    dense
    :outlined="!disabled"
    :disabled="disabled"
    :append-icon="disabled ? '' : '$dropdown'"
    @change="$emit('input', $event)"
  ></v-select>
</template>
<style lang="scss" scoped>
.v-icon--disabled {
  display: none !important;
}
</style>
